import React, { useState } from 'react';
import { 
  Container, 
  Typography, 
  Box, 
  TextField, 
  Button, 
  MenuItem,
  useTheme,
  Snackbar,
  Alert
} from '@mui/material';
import { collection, addDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { SPORTS_COLLECTIONS } from '../constants';

function UrlForm() {
  const theme = useTheme();
  const [formData, setFormData] = useState({
    url: '',
    sport: '',
    cluster_id: ''
  });
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success'
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => {
      // If sport is changing, update id to match sport
      if (name === 'sport') {
        return { ...prev, [name]: value, cluster_id: value };
      }
      return { ...prev, [name]: value };
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const urlsCollection = collection(db, 'urls');
      await addDoc(urlsCollection, formData);
      setSnackbar({
        open: true,
        message: 'URL added successfully!',
        severity: 'success'
      });
      // Reset form
      setFormData({
        url: '',
        sport: '',
        cluster_id: ''
      });
    } catch (error) {
      console.error("Error adding URL:", error);
      setSnackbar({
        open: true,
        message: 'Error adding URL',
        severity: 'error'
      });
    }
  };

  return (
    <Box sx={{ 
      minHeight: '100vh',
      backgroundColor: theme.palette.grey[100],
      pt: 3,
      pb: 6
    }}>
      <Container maxWidth="sm">
        <Typography 
          variant="h3" 
          component="h1" 
          gutterBottom
          sx={{
            textAlign: 'center',
            fontWeight: 700,
            color: theme.palette.primary.main,
            mb: 4,
            textTransform: 'uppercase',
            letterSpacing: '0.1em'
          }}
        >
          Add URL
        </Typography>
        <Box 
          component="form" 
          onSubmit={handleSubmit}
          sx={{
            backgroundColor: 'white',
            p: 3,
            borderRadius: 2,
            boxShadow: theme.shadows[1]
          }}
        >
          <TextField
            fullWidth
            label="URL"
            name="url"
            value={formData.url}
            onChange={handleChange}
            margin="normal"
            required
          />
          <TextField
            fullWidth
            select
            label="Sport"
            name="sport"
            value={formData.sport}
            onChange={handleChange}
            margin="normal"
            required
          >
            {SPORTS_COLLECTIONS.map((sport) => (
              <MenuItem key={sport} value={sport}>
                {sport.toUpperCase()}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            fullWidth
            label="ID"
            name="cluster_id"
            value={formData.cluster_id}
            onChange={handleChange}
            margin="normal"
            required
          />
          <Button 
            type="submit"
            variant="contained"
            fullWidth
            sx={{ mt: 3 }}
          >
            Submit
          </Button>
        </Box>
      </Container>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar(prev => ({ ...prev, open: false }))}
      >
        <Alert severity={snackbar.severity}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
}

export default UrlForm; 